<template>
  <div style="min-width: 900px;">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="题目" prop="name1">
        <el-input v-model="ruleForm.name1" placeholder="请输入题目内容" class="asideCol"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="date" label="发布时间">
            <el-date-picker
              class="asideCol"
              v-model="ruleForm.date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="width: 625px;">
          <el-form-item label="公司" prop="name2">
            <el-input v-model="ruleForm.name2" placeholder="请输入公司名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="内容" prop="desc">
        <div :class="{ 'Editor': detailsChecked }" class="asideCon">
          <MyEditor
            :detailsChecked="detailsChecked"
            :myHtml="ruleForm.desc"
            myEditorType="NewsContent"
            @handleMyEditor="handleMyEditor"
            :edit="!detailsChecked"
          ></MyEditor>
        </div>
      </el-form-item>

      <el-row class="footerDiv">
        <el-button @click="handleCancelNews('ruleForm')">取 消</el-button>
        <el-button type="primary" v-if="!detailsChecked" @click="handleSaveNews('ruleForm')">保 存</el-button>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import MyEditor from "@/components/Common/EditorVue.vue";
import { formatDate } from "@/utils/date";
export default {
  name: "News",
  components: {
    MyEditor
  },
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    var validatedesc = (rule, value, callback) => {
      console.log(value);
      if (value === "<p><br></p>") {
        callback(new Error("请输入新闻内容"));
      } else {
        callback();
      }
    };
    return {
      id: "",
      newsTitle: "",
      newsContent: "",
      createTime: null,
      releaseTime: null,
      createBy: "",
      company: "大连海大智龙科技有限公司",
      edit: false,
      detailsChecked: false,
      ruleForm: {
        name1: "",
        name2: "大连海大智龙科技有限公司",
        date: "",
        desc: ""
      },
      rules: {
        name1: [{ required: true, message: "请输入题目内容", trigger: "blur" }],
        date: [
          {
        
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        desc: [
          { validator: validatedesc, trigger: "blur" },
          { validator: validatedesc, trigger: "change" }
        ]
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.detailsChecked = this.params.detailsChecked || false;
      if (this.params.id) {
        this.edit = true;
        this.id = this.params.id;
        this.ruleForm.date = this.formatDate(this.params.releaseTime) || "";
        this.ruleForm.name1 = this.params.newsTitle || "";
        this.ruleForm.desc = this.params.newsContent || "";
        this.createBy = this.params.createBy || "";
      } else {
        this.ruleForm.date = this.formatDate(new Date());
      }
    },
    handleMyEditor(val) {
      
      if (val.editorType === "NewsContent") {
        this.ruleForm.desc = val.html;
      }
    },
    handleCancelNews(formName) {
      this.$emit("close");
      this.cleanDialog();
      this.$refs[formName].resetFields();
    },
    handleSaveNews(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const newsData = {
            newsTitle: this.ruleForm.name1,
            newsContent: this.ruleForm.desc,
            company: this.ruleForm.name2,
            createTime: this.createTime,
            releaseTime:  this.ruleForm.date
          };
          if (this.edit && this.id) {
            newsData.id = this.id;
          }
          this.$emit("handleSaveNews", newsData);
          this.cleanDialog();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    formatDate(time) {
        let date = new Date(time);
        return formatDate(date, "yyyy-MM-dd");
      },

    cleanDialog() {
      this.id = "";
      this.newsTitle = "";
      this.newsContent = "";
      this.company = "大连海大智龙科技有限公司";
      this.createTime = null;
      this.releaseTime = null;
      this.createBy = "";
      this.edit = false;
      this.detailsChecked = false;
    }
  }
};
</script>

<style scoped>
.Div {
  margin-top: 15px;
  text-align: left;
}
.asideCol {
  font-size: 16px;
  width: 90%;
}
.asideCon {
  width: 90%;
  font-size: 16px;
}
.footerDiv {
  text-align: right;
  margin: 30px;
  padding-right: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Common/newsTypes.vue